<template>
  <div>
      <h5 class="pl-2 mt-2">{{text}} Transporter</h5>
    <table class="table">
      <thead>
         <tr>
          <th>Karesidenan</th>
          <th>Total</th>
          <th>Target</th>
          <th>Average Duration</th>
          <th>%Hit Traget<br>(No. of Rit)</th>
          <th>%Miss Traget<br>(No. of Rit)</th>
          <th>1 Day</th>
          <th>2 Days</th>
          <th>3-4 Days</th>
          <th>> 5 Days</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="dat in ((showAll) ? data : data.slice(0, 4))">
            <td>{{ dat.karesidenan}}</td>
            <td>{{numberWithCommas(dat.total)}}</td>
            <td>{{ dat.target }} Day{{(dat.target > 1) ? 's' : ''}}</td>
            <td>{{ dat.avg }} Day{{(dat.avg > 1) ? 's' : ''}}</td>
            <td>{{ (dat.hit_target / dat.total * 100).toFixed(1) }} % ({{ numberWithCommas(dat.hit_target == '-' ? 0 : dat.hit_target) }})</td>
            <td>{{ (dat.miss_target / dat.total * 100).toFixed(1) }}% ({{ numberWithCommas(dat.miss_target == '-' ? 0 : dat.miss_target) }})</td>
            <td>{{ Math.round(dat.day_1 / dat.total * 1000) / 10 }}%</td>
            <td>{{ Math.round(dat.day_2 / dat.total * 1000) / 10 }}%</td>
            <td>{{ Math.round(dat.day_3_4 / dat.total * 1000) / 10 }}%</td>
            <td>{{ Math.round(dat.day_5 / dat.total * 1000) / 10 }}%</td>
        </tr>
        <tr v-if="showAllButton">
          <td v-if="!showAll" colspan="9" class="moreButton" @click="showAll = true">Lihat Semua</td>
          <td v-else colspan="9" class="moreButton" @click="showAll = false">Sembunyikan</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        showAllButton : false,
        showAll : true,
      }
    },
    props:['filter','period', 'data' , 'type' ,'text'],
    mounted () {

    }
  }
</script>

<style scoped>
  table tr th, table tr td {
    text-align: center;
    vertical-align: middle;
  }

  table tr th {
    border-bottom: 1px solid #F75047;
  }

</style>